<template>
  <div class="column">
    <div class="mrs mbm flex-container">
      <span class="text-left medium-3 small-12">
        <h6>Registros de Pago</h6>
        Ganado: {{ earnings }}
      </span>
      <div class="text-right medium-9 small-12">
        <div class="row">
          <div class="small-12 medium-6 flex-container align-middle">
            <label for="status">Estado:</label>
            <select v-model="status" :disabled="!enabled" class="mbn mls mrs">
              <option
                v-for="(option, index) in statusOptions"
                :key="index"
                :value="option.value"
                :disabled="!enabled"
                class="mls mr"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div class="small-12 medium-6 flex-container align-middle">
            <label for="sortBy" style="white-space: nowrap"
              >Ordenar por:</label
            >
            <select v-model="sortBy" :disabled="!enabled" class="mbn mls">
              <option
                v-for="(option, index) in sortOptions"
                :key="index"
                :value="option.value"
                :disabled="!enabled"
                class="mls mrs"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
    earnings: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      sortBy: null,
      statusOptions: [
        {
          label: 'Todo',
          value: null,
        },
        {
          label: 'provisional',
          value: 'Interim',
        },
        {
          label: 'Pendiente',
          value: 'Pending',
        },
        {
          label: 'Aprueba',
          value: 'Approved',
        },
        {
          label: 'Terminado',
          value: 'Completed',
        },
        {
          label: 'Retenido',
          value: 'Held',
        },
        {
          label: 'Fallido',
          value: 'Failed',
        },
      ],
      sortOptions: [
        {
          label: 'Fecha seleccionada',
          value: null,
        },
        {
          label: 'Fecha de pago',
          value: 'Payment Date',
        },
        {
          label: 'Estado',
          value: 'Status',
        },
      ],
    };
  },
  watch: {
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
    async sortBy(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
  },
  methods: {
    async update() {
      if (!this.enabled) {
        return;
      }
      this.$emit('filter-update', {
        status: this.status,
        sortBy: this.sortBy,
      });
    },
  },
};
</script>
